import {AbstractPlayableContent, TemporalIndicators} from "./AbstractPlayableContent";

export class Section extends AbstractPlayableContent {
  constructor(sectionId: number, temporalIndicators: TemporalIndicators, baseModel: any) {
    super('section', sectionId, 'Section '+baseModel.info, temporalIndicators, baseModel, []);
  }

  get chipColor(): string {
    const letter = this.baseModel.info[0];
    return colors.get(letter) ?? '#9E37F9';
  }

  get rhythmicBlocs() {
    return this.baseModel.rhythmic_bloc_repartitions?.filter((entry: any) => entry.rhythmic_bloc.is_primary) ?? []
  }
}

const colors = new Map<string, string>([
  ["A", '#FF3F2E'],
  ["B", '#247FFF'],
  ["C", '#2CA700'],
  ["D", '#FFDA02'],
  ["E", '#FF8641'],
  ["F", '#FE29F0'],
  ["G", '#24CCFF'],
  ["H", '#20C28A'],
  ["I", '#B1FF21'],
  ["J", '#9E37F9'],
  ["I", '#2CA700'],
])

export const defaultSection = new Section(-1, new TemporalIndicators(), {info: ''});
